import React from "react";
import {
  WixDesignSystemProvider,
} from "@wix/design-system";
import "@wix/design-system/styles.global.css";
import { withProviders } from "../../withProviders";
import "../index.css";
import Subscribe from "../../../components/Subscription";

const Index = () => {
  return (
    <WixDesignSystemProvider>
      <Subscribe wantsToUpgrade={true} />
    </WixDesignSystemProvider>
  );
};

export default withProviders(Index);
